import React from "react";
import './Home.css';
import mainImage from '../images/header.webp';
import background from '../images/background.jpg';
import {Contact} from "./Contact";
import {About} from "./About";
import WorkingProcess from "./WorkingProcess";
import { Booking } from "./Booking";
import SecviveSlider from "./SecviveSlider";
import Navbar from "../Navbar/Navbar"
import ScrollToTopButton from "./ScrollToTopButton";
import { Blog } from "./Blog";


function Home() {
  return (
    <>
    <header>
      <div className="container">
        <div className="row">
            
            <div className="col-md-7 col-lg-7 ">
                <h5>We Provide All Health Care Solution</h5>
                <h2>Protect Your Health And Take Care To Of Your Health</h2>
                <button className="btn"><a href="#">Read more</a></button>
            </div>
            <div className="col-md-5 col-lg-5 text-end parent">
              <div className="image"><img src={mainImage} alt="main" className="img-fluid"/></div>
              <div className="box">
              </div>
            </div>
                

        </div>
      </div>
    </header>
    <About/>
    <br/>
    <WorkingProcess/>
    <br/>
    <br/>
    <Booking/>
    <br/>
    <br/>
    <br/>
    <SecviveSlider/>
    <br/>
    <div className="blog">
      <h4>Latest News</h4>
      <h2>Our Latest News</h2>
    </div>
    <Blog/>
    <ScrollToTopButton/>
    </>
  
  );
}
export default Home;